module.exports = __webpack_public_path__ + "static/media/publicsonar_naturaldisaster_default.025a9fd0.svg";